let box = document.querySelector('.animation-item > div');
let height = box.offsetHeight;

var a_height = window.innerHeight ;
// console.log('mac height,'+ a_height);


var controller = new ScrollMagic.Controller({});

// var tween = TweenMax.to("#animation-img-1", 1, {className: "+=active"});

var tween_second = TweenMax.to("#animation-img-2", 1, {y:145}, {y: 0});

var tween_first_line = TweenMax.to("#animation-text-1 .animation-line", 1, {y:50}, {y: 0});

var tween_second_line = TweenMax.to("#animation-text-2 .animation-line", 1, {y:177}, {y: 0});

var tween_third_line = TweenMax.to("#animation-text-3 .animation-line", 1, {y:100}, {y: 0});

var tween_third = TweenMax.to("#animation-img-3", 1, {className: "+=active",y:-223}, {y: 0});



// var scene = new ScrollMagic.Scene({triggerElement: ".images-over", duration: 968,triggerHook: 0.3})
// .setPin(".images-over")
// .addIndicators({name: "1 (duration: 300)"}) // add indicators (requires plugin)
// .addTo(controller);
if (a_height < 900) {
     console.log('text');
    var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-1", duration: 150, offset: 40})
    .setTween(tween_first_line)
    .setClassToggle("#animation-text-1", "active") // add class toggle
   // .addIndicators() // add indicators (requires plugin)
    .addTo(controller);

    var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-2", duration: 177,offset: 100})
     .setTween(tween_second_line)
     .setClassToggle("#animation-text-2", "active") // add class toggle
    // .addIndicators() // add indicators (requires plugin)
     .addTo(controller);

     var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-3", duration: 177,offset: 0})
     .setTween(tween_third_line)
     .setClassToggle("#animation-text-3", "active") // add class toggle
    // .addIndicators() // add indicators (requires plugin)
     .addTo(controller);
} else if (a_height < 1000) {
    console.log('Bhargav');
    var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-1", duration: 150, offset: 40})
    .setTween(tween_first_line)
    .setClassToggle("#animation-text-1", "active") // add class toggle
   // .addIndicators() // add indicators (requires plugin)
    .addTo(controller);

    var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-2", duration: 177,offset: 100})
     .setTween(tween_second_line)
     .setClassToggle("#animation-text-2", "active") // add class toggle
   //  .addIndicators() // add indicators (requires plugin)
     .addTo(controller);

     var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-3", duration: 177,offset: 200})
     .setTween(tween_third_line)
     .setClassToggle("#animation-text-3", "active") // add class toggle
  //   .addIndicators() // add indicators (requires plugin)
     .addTo(controller);
} else if (a_height < 1100){
   // console.log('second');
    var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-1", duration: 150, offset: 40})
        .setTween(tween_first_line)
        .setClassToggle("#animation-text-1", "active") // add class toggle
      //  .addIndicators() // add indicators (requires plugin)
        .addTo(controller);

    var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-2", duration: 177,offset: 120})
        .setTween(tween_second_line)
        .setClassToggle("#animation-text-2", "active") // add class toggle
     //   .addIndicators() // add indicators (requires plugin)
        .addTo(controller);

        var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-3", duration: 177,offset: 100})
        .setTween(tween_third_line)
        .setClassToggle("#animation-text-3", "active") // add class toggle
      //  .addIndicators() // add indicators (requires plugin)
        .addTo(controller);
} else if (a_height < 1210){
  //  console.log('second 1200');
    var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-1", duration: 150, offset: 40})
        .setTween(tween_first_line)
        .setClassToggle("#animation-text-1", "active") // add class toggle
      //  .addIndicators() // add indicators (requires plugin)
        .addTo(controller);

    var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-2", duration: 177,offset: 200})
        .setTween(tween_second_line)
        .setClassToggle("#animation-text-2", "active") // add class toggle
      //  .addIndicators() // add indicators (requires plugin)
        .addTo(controller);

        var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-3", duration: 177,offset: 100})
        .setTween(tween_third_line)
        .setClassToggle("#animation-text-3", "active") // add class toggle
    //    .addIndicators() // add indicators (requires plugin)
        .addTo(controller);
} else if (a_height < 1370){
     //   console.log('second 1370');

        var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-1", duration: 150, offset: 40})
        .setTween(tween_first_line)
        .setClassToggle("#animation-text-1", "active") // add class toggle
     //   .addIndicators() // add indicators (requires plugin)
        .addTo(controller);

        var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-2", duration: 177,offset: 300})
         .setTween(tween_second_line)
         .setClassToggle("#animation-text-2", "active") // add class toggle
     //    .addIndicators() // add indicators (requires plugin)
         .addTo(controller);

         var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-3", duration: 177,offset: 400})
         .setTween(tween_third_line)
         .setClassToggle("#animation-text-3", "active") // add class toggle
     //    .addIndicators() // add indicators (requires plugin)
         .addTo(controller);

} else if (a_height < 1501){
   // console.log('thid');
    var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-1", duration: 150, offset: 40})
    .setTween(tween_first_line)
    .setClassToggle("#animation-text-1", "active") // add class toggle
  //  .addIndicators() // add indicators (requires plugin)
    .addTo(controller);

    var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-2", duration: 177,offset: 340})
     .setTween(tween_second_line)
     .setClassToggle("#animation-text-2", "active") // add class toggle
  //   .addIndicators() // add indicators (requires plugin)
     .addTo(controller);

     var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-3", duration: 177,offset: 400})
     .setTween(tween_third_line)
     .setClassToggle("#animation-text-3", "active") // add class toggle
   //  .addIndicators() // add indicators (requires plugin)
     .addTo(controller);
} else if (a_height < 1650){
  //  console.log('thid 1600');
    var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-1", duration: 150, offset: 40})
    .setTween(tween_first_line)
    .setClassToggle("#animation-text-1", "active") // add class toggle
 //   .addIndicators() // add indicators (requires plugin)
    .addTo(controller);

    var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-2", duration: 177,offset: 400})
        .setTween(tween_second_line)
        .setClassToggle("#animation-text-2", "active") // add class toggle
  //      .addIndicators() // add indicators (requires plugin)
        .addTo(controller);

        var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-3", duration: 177,offset: 400})
        .setTween(tween_third_line)
        .setClassToggle("#animation-text-3", "active") // add class toggle
     //   .addIndicators() // add indicators (requires plugin)
        .addTo(controller);
} else if (a_height < 1700){
   // console.log('thid 1700');
    var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-1", duration: 150, offset: 40})
        .setTween(tween_first_line)
        .setClassToggle("#animation-text-1", "active") // add class toggle
      //  .addIndicators() // add indicators (requires plugin)
        .addTo(controller);

    var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-2", duration: 177,offset: 410})
        .setTween(tween_second_line)
        .setClassToggle("#animation-text-2", "active") // add class toggle
      //  .addIndicators() // add indicators (requires plugin)
        .addTo(controller);

    var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-3", duration: 177,offset: 400})
        .setTween(tween_third_line)
        .setClassToggle("#animation-text-3", "active") // add class toggle
      //  .addIndicators() // add indicators (requires plugin)
        .addTo(controller);
} else if (a_height < 1820){
   // console.log('thid 1800');
    var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-1", duration: 150, offset: 40})
        .setTween(tween_first_line)
        .setClassToggle("#animation-text-1", "active") // add class toggle
     //   .addIndicators() // add indicators (requires plugin)
        .addTo(controller);

    var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-2", duration: 177,offset: 500})
        .setTween(tween_second_line)
        .setClassToggle("#animation-text-2", "active") // add class toggle
     //   .addIndicators() // add indicators (requires plugin)
        .addTo(controller);

    var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-3", duration: 177,offset: 600})
        .setTween(tween_third_line)
        .setClassToggle("#animation-text-3", "active") // add class toggle
      //  .addIndicators() // add indicators (requires plugin)
        .addTo(controller);
} else if (a_height < 1921){
   // console.log('thid 1920');
    var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-1", duration: 150, offset: 40})
        .setTween(tween_first_line)
        .setClassToggle("#animation-text-1", "active") // add class toggle
     //   .addIndicators() // add indicators (requires plugin)
        .addTo(controller);

    var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-2", duration: 177,offset: 600})
        .setTween(tween_second_line)
        .setClassToggle("#animation-text-2", "active") // add class toggle
      //  .addIndicators() // add indicators (requires plugin)
        .addTo(controller);

    var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-3", duration: 177,offset: 600})
        .setTween(tween_third_line)
        .setClassToggle("#animation-text-3", "active") // add class toggle
     //   .addIndicators() // add indicators (requires plugin)
        .addTo(controller);
} else{
    //console.log('vekariya');
    var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-1", duration: 150, offset: 40})
    .setTween(tween_first_line)
    .setClassToggle("#animation-text-1", "active") // add class toggle
   // .addIndicators() // add indicators (requires plugin)
    .addTo(controller);

    var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-2", duration: 177,offset: 400})
     .setTween(tween_second_line)
     .setClassToggle("#animation-text-2", "active") // add class toggle
   //  .addIndicators() // add indicators (requires plugin)
     .addTo(controller);

     var scene = new ScrollMagic.Scene({triggerElement: "#animation-text-3", duration: 177,offset: 400})
     .setTween(tween_third_line)
     .setClassToggle("#animation-text-3", "active") // add class toggle
  //   .addIndicators() // add indicators (requires plugin)
     .addTo(controller);
}


var scene = new ScrollMagic.Scene({triggerElement: ".animation-item-2", duration: height * 1.4,offset: height * 0.4})
    .setTween(tween_second)

  //  .addIndicators() // add indicators (requires plugin)
    .addTo(controller);

    if (a_height > 1800){
      console.log('1800 + 3');
        var scene = new ScrollMagic.Scene({triggerElement: ".animation-item-3", duration: height,offset: 200})
        .setTween(tween_third)
   //     .addIndicators() // add indicators (requires plugin)
        .addTo(controller);
    }  
    else if (a_height < 999){
        console.log('900 - 3');
        var scene = new ScrollMagic.Scene({triggerElement: ".animation-item-3", duration: height,offset: -100})
        .setTween(tween_third)
     //   .addIndicators() // add indicators (requires plugin)
        .addTo(controller);
    }
    else{
        var scene = new ScrollMagic.Scene({triggerElement: ".animation-item-3", duration: height})
        .setTween(tween_third)
     //   .addIndicators() // add indicators (requires plugin)
        .addTo(controller);
    }

window.addEventListener("scroll", function(){

});